import React from 'react';

import Button from '../../../components/buttons/Button';
import { NavigationDetail, NavigationLevel } from '../templateTypes';

import './BoardTemplatePickerBodyListingCategoryButton.scss';

type Props = {
    children: React.ReactNode;
    categoryId: string;
    setNavigation: (navigation: NavigationDetail) => void;
};

const BoardTemplatePickerBodyListingCategoryButton = ({ children, categoryId, setNavigation }: Props) => (
    <Button
        className="TemplatePickerListingButton CategoryButton"
        onClickFn={() =>
            setNavigation({
                level: NavigationLevel.SUBCATEGORIES,
                categoryId,
            })
        }
    >
        {children}
    </Button>
);

export default BoardTemplatePickerBodyListingCategoryButton;
